<template>
  <section>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-4"></div>
          <div class="col-md-4">
            <a @click.prevent="restoreAction" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
              <span>
                <i class="flaticon-tool"></i>
                <span>{{ 'restore' | translate | capitalize }}</span>
              </span>
            </a>
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="resetForm" id="btn-cancel">
        {{ 'close' | translate | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions(['restore', 'setStatusRestoreModal']),
    resetForm () {
      window.$('#restore_modal').modal('hide')
      this.setStatusRestoreModal(false)
    },
    restoreAction () {
      this.$spinner.show()
      this.restore()
        .then(() => {
          this.$spinner.remove()
          window.location.reload()
        })
        .catch(() => {
          this.$spinner.remove()
          window.location.reload()
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Restore.vue